<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <v-container>
      <data-table
        ref="table"
        :fetch-from="fetchForm"
        :fields="fields"
      >
        <template
          slot="actions"
          slot-scope="slotData"
        >
          <v-btn
            x-small
            color="primary"
            @click="showDetails(slotData.rowData)"
          >Edit</v-btn>
        </template>
      </data-table>
      <v-btn
        v-if="!isReadOnly()"
        color="primary"
        small
        @click="showAddDialog()"
      >
        Add tenant
      </v-btn>
      <modal-form
        title="Tenant"
        :show="dialog"
        @update:show="dialog=$event"
        v-on:saveData="doSave"
        :readonly="isReadOnly()"
      >
        <v-form v-model="valid">
          <v-row>
            <v-col cols="4">
              <tenant-type
                :readonly="isReadOnly()"
                label="Tenant type"
                :value="getValue(item, 'tenant_type_id')"
                @input="setValue(item, 'tenant_type_id', $event)"
              ></tenant-type>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Tenant Site ID & Site Name"
                :value="getValue(item, 'site_id_site_name')"
                @input="setValue(item, 'site_id_site_name', $event)"
              ></text-field>
            </v-col>
            <v-col cols="4">
              <site-infrastructure-owner
                :readonly="isReadOnly()"
                label="Site infrastructure owner"
                :value="getValue(item, 'site_infrastructure_owner')"
                @input="setValue(item, 'site_infrastructure_owner', $event)"
              ></site-infrastructure-owner>
            </v-col>
          </v-row>
        </v-form>
        <h3>Rents</h3>
        <rents
          :value="getValue(item, 'rents')"
          @input="setValue(item, 'rents', $event)"
          :site="site"
        ></rents>
      </modal-form>
    </v-container>
  </permissions-view>
</template>

<script>
  import TextField from '@/components/TextField'
  import SiteInfrastructureOwner from '@/components/codelist/SiteInfrastructureOwner'
  import Rents from '@/views/sites/sections/tenant/Rents'
  import ModalForm from '@/components/ModalForm'
  import ReactivityMixin from '@/mixins/Reactivity'
  import DataTable from '@/components/DataTable'
  import SiteTenantService from '@/services/site-tenant'
  import PermissionsView from '@/components/PermissionsView'
  import PermissionsMixin from '@/mixins/Permissions'
  import TenantType from '@/components/codelist/TenantType'
  export default {
    name: 'Tenant',
    mixins: [
      ReactivityMixin,
      PermissionsMixin,
    ],
    components: { TenantType, PermissionsView, DataTable, ModalForm, Rents, SiteInfrastructureOwner, TextField },
    props: {
      site: {
        default: null,
      },
      active: {
        default: false,
      },
    },
    data: () => ({
      dialog: false,
      item: {},
      fields: [
        {
          name: 'tenant_type_name',
          title: 'Tenant type',
        },
        {
          name: 'site_id_site_name',
          title: 'Site id/name',
        },
        {
          name: 'site_infrastructure_owner_name',
          title: 'Site infrastructure owner',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
        },
      ],
      section: 'tenant',
    }),
    computed: {
      isEditing () {
        return this.item.id !== undefined
      },
    },
    methods: {
      fetchForm (urls, options) {
        const sts = new SiteTenantService(this.site.id)
        return sts.list(options.params)
      },
      showAddDialog () {
        this.item = {
          rents: [],
        }
        this.dialog = true
      },
      showDetails (item) {
        this.item = JSON.parse(JSON.stringify(item))
        this.dialog = true
      },
      doSave () {
        if (this.isEditing) {
          const sts = new SiteTenantService(this.site.id)
          sts.put(this.item.id, this.item).then(() => {
            this.$refs.table.refresh()
            this.dialog = false
          })
        } else {
          const sts = new SiteTenantService(this.site.id)
          sts.post(this.item).then(() => {
            this.$refs.table.refresh()
            this.dialog = false
          })
        }
      },
    },
  }
</script>

<style scoped>

</style>
